import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const CodeDisplayBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: theme.spacing(2),
	padding: theme.spacing(3, 4),
	margin: theme.spacing(3, 0),
	backgroundColor: theme.palette.grey[50],
	borderRadius: (theme.shape.borderRadius as number) * 2,
	border: `2px dashed ${theme.palette.divider}`,
}));

export const BigCodeText = styled(Box)(({ theme }) => ({
	fontFamily: 'monospace',
	fontSize: '2rem',
	fontWeight: 700,
	letterSpacing: '0.2em',
	color: theme.palette.primary.main,
	userSelect: 'all',
}));

export const CopyButton = styled(Button)(({ theme }) => ({
	textTransform: 'none',
	fontWeight: 600,
	flexShrink: 0,
	borderRadius: theme.shape.borderRadius,
}));

export const ModalActions = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	gap: theme.spacing(1.5),
	padding: theme.spacing(2, 3, 3),
}));
